export default __webpack_public_path__ + "static/media/BRIGITTE.526910cb.png";